import React from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { useGetLoanApplication, useGetLoanApplicationByTask } from '../../../services/loanService';
import IndividualLoanApplicationDocuments from './IndividualLoanApplicationDocuments';
import LoanApplicationDocuments from './LoanApplicationDocuments';

const PendingDocuments: React.FC<{ isError?: boolean }> = ({ isError }) => isError
  ? <div role="alert">Unable to load the application. Refresh the page to try again.</div>
  : <div role="status">Loading document details...</div>;

const DocumentsByTask: React.FC<{ taskId: string }> = ({ taskId }) => {
  const { data: application, isError } = useGetLoanApplicationByTask(taskId);
  return application?.id
    ? <Navigate replace to={`/loan-application-documents/${encodeURIComponent(application.id)}`} />
    : <PendingDocuments isError={isError} />;
};

const DocumentsByApplication: React.FC<{ id: string }> = ({ id }) => {
  const { data: loanApplication, isError } = useGetLoanApplication(id, {});
  if (!loanApplication) return <PendingDocuments isError={isError} />;
  return loanApplication.loanType === 'PERSONAL'
    ? <IndividualLoanApplicationDocuments />
    : <LoanApplicationDocuments />;
};

const LoanApplicationDocumentsRoute: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [params] = useSearchParams();
  return params.get('fromTask') === 'true'
    ? <DocumentsByTask taskId={id || ''} />
    : <DocumentsByApplication id={id || ''} />;
};

export default LoanApplicationDocumentsRoute;
